"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCategories = void 0;
var hooks_1 = require("../../hooks");
var useCategories = function () {
    return (0, hooks_1.useAppSelector)(function (state) { return state.categories; });
};
exports.useCategories = useCategories;
